import React from 'react';
import type { ChatStep } from '../../../../types/stream.types';
import type { ToolRenderer, ToolSummary, ToolContent } from '../tool-renderer.types';
import { FileText } from 'lucide-react';

export class DocumentToolRenderer implements ToolRenderer {
  getSummary(step: ChatStep, isStreaming: boolean): ToolSummary {
    const metadata = step.output?.metadata;

    if (metadata?.total_items) {
      return {
        text: `${metadata.total_items} ${metadata.total_items === 1 ? 'document' : 'documents'}`,
        icon: <FileText size={10} className="text-gray-400" />,
      };
    }

    if (metadata?.document_ids && Array.isArray(metadata.document_ids) && metadata.document_ids.length) {
      const n = metadata.document_ids.length;
      return {
        text: `${n} ${n === 1 ? 'document' : 'documents'}`,
        icon: <FileText size={10} className="text-gray-400" />,
      };
    }

    if (metadata?.document_name && typeof metadata.document_name === 'string') {
      return {
        text: metadata.document_name,
        icon: <FileText size={10} className="text-gray-400" />,
      };
    }

    return {
      text: isStreaming ? 'Processing documents...' : 'Completed',
      icon: <FileText size={10} className="text-gray-400" />,
    };
  }

  getContent(step: ChatStep): ToolContent {
    const content = step.output?.content || '';
    const metadata = step.output?.metadata;

    return {
      main: (
        <div className="text-xs text-gray-500 leading-relaxed whitespace-pre-wrap">
          {content || 'No content'}
        </div>
      ),
      metadata:
        metadata &&
        (metadata.total_items ||
          (Array.isArray(metadata.document_ids) && metadata.document_ids.length) ||
          metadata.document_name) ? (
          <div className="flex items-center gap-1.5 text-[10px] text-gray-400 mt-2 pt-2 border-t border-gray-100/50">
            <FileText size={10} className="text-gray-300" />
            <span>
              {metadata.total_items
                ? `${metadata.total_items} ${metadata.total_items === 1 ? 'document' : 'documents'}`
                : Array.isArray(metadata.document_ids) && metadata.document_ids.length
                  ? `${metadata.document_ids.length} ${metadata.document_ids.length === 1 ? 'document' : 'documents'}`
                  : String(metadata.document_name || 'Document')}
            </span>
          </div>
        ) : undefined,
    };
  }
}
